import enviro from 'enviro';
const getClientId = () => {
  if (enviro.getShort() === 'qa') {
    return '865670317198-asthmgevab32f2bpel9a9e53l6vvfirv.apps.googleusercontent.com';
  }
  return '466680526474.apps.googleusercontent.com';
};
const getDeveloperKey = () => {
  if (enviro.getShort() === 'qa') {
    return 'AIzaSyDrMTD0gVKi7Be8-UTD3-Lgk7tsqVgSZWA';
  }
  return 'AIzaSyAtESehG2a1rDN0VYuQhL9nbvYwI4ZIO6c';
};
const getScope = () => {
  return 'https://www.googleapis.com/auth/drive.readonly';
};
export default (() => ({
  applicationId: 'alert-inquiry-642',
  developerKey: getDeveloperKey(),
  authOptions: {
    client_id: getClientId(),
    scope: getScope(),
    ux_mode: 'popup'
  },
  mimeTypes: 'application/vnd.google-apps.presentation,application/pdf,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.ms-powerpoint'
}));